import React, { useEffect, useState, useContext } from 'react';
import app, { firebaseObj } from './firebaseStart';
import firebaseUtil from '../data/FirebaseUtil';
import {useTranslation} from "react-i18next";
import {SSOSettingsContext} from '../authentication/SSOSettings';
import {logoutSSOUser} from '../Services/userService'
import { SSO_CONSTANTS } from '../data/constants'
import { userJustManager } from '../data/userUtil';
export const AuthContext = React.createContext();
export const useAuthContext = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
    const [currentUser, setCurrentUser] = useState(null);
    const [pending, setPending] = useState(true);
    const { SSOSettings } = useContext(SSOSettingsContext);
    const { t } = useTranslation();

    useEffect(() => {
        app.auth().onAuthStateChanged(async (user) => {
            if (user) {
                let idTokenResult = (await user.getIdTokenResult())
                user.claims = idTokenResult.claims
                if(userJustManager(user.claims)){
                    if(user.claims.siteName){
                        user.claims.siteArr = Array.isArray(user.claims.siteName) ? user.claims.siteName : user.claims.siteName.split(",")
                        user.claims.siteArr = user.claims.siteArr.length > 0 ? user.claims.siteArr.map(site=>site.toUpperCase()): user.claims.siteArr
                    }else{
                        user.claims.siteArr = []
                    }
                    user.claims.siteArr.sort(function(a, b) {
                        return a.localeCompare(b, undefined, { numeric: true });
                    })
                }
                userOnDeleteListener(user);
                refreshTokenHandler(user.claims.ssoToken);
            }
            setCurrentUser(user);
            setPending(false);
        });
    }, []);

    function userOnDeleteListener(user) {
        try {
            app.firestore().collection("tenants").doc(user.claims.companyID)
                .collection("Users").where('emailId', '==', user.email)
                .onSnapshot((querySnapshot) => {
                    let docArr = querySnapshot.docChanges()
                    if (docArr.length > 0 && docArr[0].type === 'removed')
                        return app.auth().signOut()
                }, (error) => {
                    //console.log(error)
                })
        } catch (error) {
            //console.log(error)
        }
    }

    const refreshTokenHandler = async (ssoToken)=>{
        console.log("Inside xxxxx xxxx handler")
        let isSSOLogin = JSON.parse(localStorage.getItem("ssoLogin"));
        if(isSSOLogin) {
            const currentDate = new Date();
            const currentTime = currentDate.getTime()
            const {expires_at} = ssoToken;
            let  diff = expires_at - currentTime;
            console.log("Time remaining is ",diff);
            if(diff <= 0){
                await handleLogInSSO();
            }else{
                setTimeout(async ()=> await handleLogInSSO(),diff)
            }

        }
    }
    async function handleLogInSSO() {
        firebaseUtil.ssoRefreshToken().then((tokenRes) => {
            app.auth().setPersistence(firebaseObj.auth.Auth.Persistence.SESSION)
            .then(() => {
                app.auth().signInWithCustomToken(tokenRes.data.result).then(async response => {
                    console.log("xxxx Updated Successfully");
                    let idTokenResult = (await response.user.getIdTokenResult())
                    response.user.claims = idTokenResult.claims
                    await refreshTokenHandler(response.user.claims.ssoToken);
                }).catch(error => {
                    console.log("ERROR: In handleLogInSSO ")
                    handleError(error)
                })
            })
        }).catch(err =>{
            console.log("ERROR: In handleLogInSSO ")
            handleError(err)
        })
    }

    const handleError = (error)=>{
        console.log("Login error ",error.message)
        //Azure SSO
        if(SSOSettings.ssoProvider === SSO_CONSTANTS.SSO_PROVIDERS.AZURE){
            logoutSSOUser(SSOSettings).then(() => {
                    console.log("Successfully logoutSSOUser");
                }).catch((err) => {
                    console.log("Error in logoutSSOUser", err);
                    return err;
                })
        }else{
            logoutUser()
        }
    }

    const  logoutUser = () => {
        firebaseUtil.revokeTokenWithSSOServer().then(() => {
            firebaseUtil.revokeTokenAccess().then(() => {
                window.localStorage.clear()
                console.log("SSOSettings.logoutURL == ", SSOSettings.logoutURL);
                window.location.href = `${SSOSettings.logoutURL}?TargetResource=${SSOSettings.webRedirectURI}&InErrorResource=${SSOSettings.webRedirectURI}`;
            })
        })
    }

    if (pending) {
        return <>{t ("loading__")}</>
    }

    return (
        <AuthContext.Provider value={{ currentUser }}>
            {children}
        </AuthContext.Provider>
    );
}